import SignatureRegister from "components/SignatureRegister";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPrimary, ButtonPrimaryDiv, ButtonSecondary } from "../Buttons";
import AppContext from "../../../components/AppContext";
import { is1DollarTrialCampaign } from "@utils/signature_owner";
import { Button1 } from "@components/google-ads/Buttons";
import { HiArrowLongRight } from "react-icons/hi2";
import {
  CLMButtonPrimary,
  CLMButtonSecondaryBorder,
} from "components/CLM/v3/Buttons";

const CtaOne = ({
  heading1,
  heading2,
  heading3,
  paragraph,
  paragraphStyling,
  buttonsStyling,
  buttonPrimaryText,
  buttonPrimaryUrl,
  buttonPrimaryIcon,
  buttonPrimaryBorderShadow,
  buttonPrimaryNewTab,
  buttonPrimaryBg,
  buttonSecondaryText,
  buttonSecondaryUrl,
  buttonSecondaryIcon,
  buttonSecondaryNewTab,
  signaturePopupOpen,
}) => {
  const context = useContext(AppContext);
  const [signaturePopup, setSignaturePopup] = useState({
    open: false,
    mode: "register",
  });
  const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] =
    useState(false);
  const isSignaturePage = signaturePopupOpen;

  useEffect(() => {
    setIs1DollarTrialCampaignState(
      is1DollarTrialCampaign({
        utm_campaign: context?.globalData?.utmData?.utm_campaign,
      })
    );
  }, [context?.globalData?.utmData?.utm_campaign]);

  return (
    <div className="flex flex-col gap-7 sm:gap-8">
      <SignatureRegister
        isPopupOpen={signaturePopup.open && isSignaturePage}
        mode={signaturePopup.mode}
        setIsPopupOpen={(value) =>
          setSignaturePopup((prev) => ({ ...prev, open: value }))
        }
        setMode={(mode) =>
          setSignaturePopup((prev) => ({ ...prev, mode: mode }))
        }
      />
      {heading1 && (
        <h1 className="font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl">
          {heading1}
        </h1>
      )}
      {heading2 && (
        <h2 className="font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl">
          {heading2}
        </h2>
      )}
      {heading3 && (
        <h3 className="font-bold text-2xl sm:text-3xl">{heading3}</h3>
      )}
      {paragraph && (
        <p className={`text-lg sm:text-xl ${paragraphStyling}`}>{paragraph}</p>
      )}
      <div
        className={`mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ${
          buttonsStyling && buttonsStyling
        }`}
      >
        {buttonPrimaryText &&
          (isSignaturePage ? (
            is1DollarTrialCampaignState ? (
              <Button1
                btnText={buttonPrimaryText}
                bgColor={buttonPrimaryBg || "bg-violet-500"}
                textColor={"text-white"}
                border="border border-violet-500  "
                showLoading={false}
                icon={<HiArrowLongRight />}
                borderShadow={buttonPrimaryBorderShadow ?? true}
                px={"px-5"}
              />
            ) : (
              <ButtonPrimaryDiv
                buttonText={buttonPrimaryText}
                onclick={() =>
                  setSignaturePopup((prev) => ({ ...prev, open: true }))
                }
                buttonUrl={buttonPrimaryUrl}
                icon={buttonPrimaryIcon}
                borderShadow={buttonPrimaryBorderShadow}
                newTab={buttonPrimaryNewTab}
                bgColor={buttonPrimaryBg}
              />
            )
          ) : (
            <CLMButtonPrimary
              buttonText={buttonPrimaryText}
              buttonUrl={buttonPrimaryUrl}
              icon={<HiArrowLongRight />}
            />
          ))}
        {buttonSecondaryText && (
          <CLMButtonSecondaryBorder
            buttonText={buttonSecondaryText}
            buttonUrl={buttonSecondaryUrl}
          />
        )}
      </div>
    </div>
  );
};

export default CtaOne;
